const UserRouter = [
    {
      path: '/user-management',
      name: 'UserManagement',
      layout: "dashboard",
      component: () => import('@/views/LandingPage/User/index.vue'),
      meta: {
        title: 'Quản lý user',
        openSidebarKey: 'user-management',
      }
    }
  ]
  
  export default UserRouter